import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/es/servicios/quality-assurance/")({
  head: () => buildRouteHead("/es/servicios/quality-assurance"),
  component: ServicePage,
});

